/* Haveli AI concierge loader (speed pass): the chat engine (Shopify Files) now loads after the page is
   interactive instead of blocking every page with a synchronous request. Listeners it registers for
   DOMContentLoaded/load are run straight away, so it behaves as before. */
(function(){
  var u='https://cdn.shopify.com/s/files/1/0829/9403/6964/files/nora-ai-v2.txt?v=1790762842',done=false;
  function run(code){
    var dAdd=document.addEventListener,wAdd=window.addEventListener,later=[];
    function wrap(orig,target){return function(t,f,o){if((t==='DOMContentLoaded'&&document.readyState!=='loading')||(t==='load'&&document.readyState==='complete')){later.push(f);return}return orig.call(target,t,f,o)}}
    document.addEventListener=wrap(dAdd,document);window.addEventListener=wrap(wAdd,window);
    try{var s=document.createElement('script');s.text=code;(document.head||document.documentElement).appendChild(s)}
    finally{document.addEventListener=dAdd;window.addEventListener=wAdd}
    later.forEach(function(f){try{typeof f==='function'?f.call(document,new Event('DOMContentLoaded')):f.handleEvent&&f.handleEvent(new Event('DOMContentLoaded'))}catch(e){console.error(e)}});
  }
  function load(){if(done)return;done=true;
    fetch(u,{credentials:'omit',cache:'force-cache'}).then(function(r){if(!r.ok)throw new Error(r.status);return r.text()}).then(run)
      .catch(function(e){console.error('Haveli AI chat failed to load',e)});
  }
  function soon(){('requestIdleCallback' in window)?requestIdleCallback(load,{timeout:1500}):setTimeout(load,300)}
  if(document.readyState==='complete')soon();else window.addEventListener('load',soon,{once:true});
  /* Load at once if the visitor interacts first. */
  ['pointerdown','touchstart','keydown','scroll'].forEach(function(t){window.addEventListener(t,load,{once:true,passive:true})});
})();
